


export class NotifType {
    application: Application;
    type: string;
    description: string;
    id: string;
}

interface Application {
    ApplicationName: string;
    id: string;
}


export class AlertNotif {
    user: User;
    notifications: NotificationAlertNotif[];

    constructor(user: User, notifications: NotificationAlertNotif[]) {
        this.user = user || null;
        this.notifications = notifications || null;
    }
}

export class NotificationAlertNotif {
    notificationType: NotificationType;
    parameterValue?: string;
    email: boolean;
    sms: boolean;

    constructor(notificationType: NotificationType, parameterValue: string, email: boolean, sms: boolean) {
        this.notificationType = notificationType || null;
        this.parameterValue = parameterValue || null;
        this.email = email;
        this.sms = sms;
    }
}

export class NotificationType {
    id: string;
    label: string;

    constructor(id: string, label: string) {
        this.id = id || null;
        this.label = label || null;
    }
}

export class User {
    id: string;
    email: string;
    gsm: string;

    constructor(id: string, email: string, gsm: string) {
        this.id = id || null;
        this.email = email || null;
        this.gsm = gsm || null;
    }
}

